/* נתיבי המערכת. נשמרו קרוב לנתיבים של האתר הקודם כדי לא לשבור קישורים קיימים. */
export const ROUTES = {
  home: '/',
  about: '/about',
  advisors: '/advisors',
  tracks: '/tracks',
  terms: '/terms',
  department: '/departments/:slug',
} as const;

/** בונה נתיב לעמוד מחלקה לפי ה-slug שלה. */
export function departmentPath(slug: string): string {
  return `/departments/${slug}`;
}

/* עוגנים בעמוד הבית */
export const HOME_ANCHORS = {
  top: '#top',
  who: '#who',
  process: '#process',
  departments: '#departments',
  about: '#about',
  contact: '#contact',
} as const;
